var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"bread",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_c('a',{attrs:{"href":"/"}},[_vm._v("活动管理")])]),_c('el-breadcrumb-item',[_vm._v("活动列表")]),_c('el-breadcrumb-item',[_vm._v("活动详情")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }